<template>
  <div class="c-form-item-acitivty-place" :class="{ disabled }">
    <table>
      <tr >
        <td
          class="place-item"
          colspan="2"
          :class="{ active: ActivityPlace.BANNER_TOP === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER_TOP)"
        >
          首页顶图
        </td>
      </tr>

      <tr>
        <td
          class="place-item"
          rowspan="2"
          :class="{ active: ActivityPlace.BANNER2_LEFT === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER2_LEFT)"
        >
          左侧瓷片
        </td>
        <td
          class="place-item"
          :class="{ active: ActivityPlace.BANNER2_RIGHT === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER2_RIGHT)"
        >
          右侧瓷片1
        </td>
      </tr>
      <tr>
        <td
          class="place-item"
          :class="{ active: ActivityPlace.BANNER_MIDDLE === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER_MIDDLE)"
        >
          右侧瓷片2
        </td>
      </tr>
      <!-- 已作废 -->
      <!--
        <tr>
        <td
          class="place-item"
          :class="{ active: ActivityPlace.BANNER2_LEFT === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER2_LEFT)"
        >
          活动位1
        </td>
        <td
          class="place-item"
          :class="{ active: ActivityPlace.BANNER2_RIGHT === activityPlace }"
          @click="handleSelect(ActivityPlace.BANNER2_RIGHT)"
        >
          活动位2
        </td>
      </tr> -->
      <tr>
        <td
          class="place-item"
          colspan="2"
          :class="{ active: ActivityPlace.AKC_BRAND_LIST === activityPlace }"
          @click="handleSelect(ActivityPlace.AKC_BRAND_LIST)"
        >
          横向商品瓷片
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import { _, computed, ref, watch, useCurrentAppInstance } from '@zto/zpage'

import { ActivityPlace } from '@/config'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    disabled?: boolean
    disabledBanner1?: boolean
  }>(),
  {
    disabled: false
  }
)

const app = useCurrentAppInstance()

const activityPlace = computed(() => {
  return props.model.activityPlace
})

function handleSelect(place?: ActivityPlace) {
  if (props.disabled) return

  if (!place) return

  props.model.activityPlace = place
}
</script>

<style lang="scss" scoped>
.c-form-item-acitivty-place {
  .place-item {
    border: 1px solid var(--border-color);
    padding: 10px;
    width: 100px;
    text-align: center;
    cursor: pointer;

    &.active {
      background: #ff8d97;
      color: white;
    }
  }

  &.disabled {
    .place-item {
      cursor: default;
    }
  }
}
</style>
